import Contact from "../components/sections/Contact";
import "./ContactPage.css";

function ContactPage() {
  return (
    <main className="contact-page">
      <Contact />
    </main>
  );
}

export default ContactPage;
